import { httpClient } from '../http/httpClient.js';

const PLANS_API_URL = '/api/plans';

const buildPlansUrl = (params = {}) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `${PLANS_API_URL}?${qs}` : PLANS_API_URL;
};

export const normalizePlan = (p) => ({
  ...p,
  id:             p.name,
  name:           p.name,
  description:    p.description,
  storageLimitMB: p.storageLimitMB,
  maxUsers:       p.maxUsers,
  price:          p.price,
  currency:       p.currency,
  isActive:      p.isActive,
  createdAt:      p.createdAt,
  updatedAt:      p.updatedAt,
});

const getPlansCollection = (payload) => {
  if (Array.isArray(payload?.responses))
    return payload.responses;
  return [];
};

export const planService = {
  getPlans: async (params = {}) => {
    const payload = await httpClient.get(buildPlansUrl(params));
    const list = getPlansCollection(payload);
    return {
      plans:      list.map(normalizePlan),
      pagination: payload?.pagination ?? null,
    };
  },

  createPlan: async ({ name, storageLimitMB, description, maxUsers, price, currency }) => {
    return httpClient.post(PLANS_API_URL, {
      data: {
        name,
        storageLimitMB: Number(storageLimitMB),
        description,
        maxUsers: Number(maxUsers),
        price: Number(price),
        currency: currency?.toUpperCase(),
      },
    });
  },

  updatePlan: async (name, { storageLimitMB, description, maxUsers, price, currency }) => {
    return httpClient.put(`${PLANS_API_URL}/${encodeURIComponent(name)}`, {
      data: {
        storageLimitMB: Number(storageLimitMB),
        description,
        maxUsers: Number(maxUsers),
        price: Number(price),
        currency: currency?.toUpperCase(),
      },
    });
  },

  deletePlan: async (name) => {
    return httpClient.delete(`${PLANS_API_URL}/${encodeURIComponent(name)}`);
  },
};
